// removed by extract-text-webpack-plugin
module.exports = {"login-account-selection-wrapper":"AccountSelection__login-account-selection-wrapper","loginAccountSelectionWrapper":"AccountSelection__login-account-selection-wrapper","signed-in-with":"AccountSelection__signed-in-with","signedInWith":"AccountSelection__signed-in-with","radio-wrapper":"AccountSelection__radio-wrapper","radioWrapper":"AccountSelection__radio-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/AccountSelection/AccountSelection.scss
// module id = 1518
// module chunks = 8